import React from 'react'
import SmallCommentInput from './SmallCommentInput'
import SmallComment from './SmallComment';
import {connect} from 'react-redux'
import {getLabel} from "../../../language";
import {APP_CONFIG} from "../../../appconfig"

const defaultAvatar = APP_CONFIG.defaultAvatar;

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user
    }
}

export class SmallCommentContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showComments: false
        };
        this.addCommentClick = this.addCommentClick.bind(this);
    }

    addCommentClick() {
        this.setState({
            showComments: true
        })
    }

    render() {
        // const comment = this.props.comments && this.props.comments[this.props.comments.length - 1];

        return (
            <div className="row small-comments">
                    <div className="col-md-12">
                    {this.props.isAvailableForReply ? <SmallCommentInput
                        addCommentClick={this.addCommentClick}
                        avatar={this.props.user && this.props.user.avatar ? this.props.user.avatar : null}
                        post={this.props.post}
                        posts={this.props.posts}
                        isAvailableForReply={this.props.isAvailableForReply}
                    /> : <p className="text-right">{getLabel(206)}</p>}
                    {this.props.comments && this.props.comments.length > 0 && this.props.post && this.props.post.id === this.state.showComments ?
                        <div>
                            {this.props.comments ?
                                this.props.comments.map((comment, index) => {
                                    return <SmallComment
                                        commentID={comment.id}
                                        key={index}
                                        {...comment}
                                        avatar={defaultAvatar}
                                        post={this.props.post}
                                        posts={this.props.posts}
                                        isAvailableForReply={this.props.isAvailableForReply}
                                    />
                                })
                                : null}
                        </div>
                        :
                        <div>
                            {this.props.showComments &&
                            this.props.comments &&
                            this.props.comments.slice(0).reverse().map((Comment, index) => {
                                return (<div>
                                    <SmallComment
                                        {...Comment}
                                        mention={this.props.mentions}
                                        avatar={defaultAvatar}
                                        post={this.props.post}
                                        posts={this.props.posts}
                                        isAvailableForReply={this.props.isAvailableForReply}
                                    />
                                    {/*{this.props.comments.length > 1 && this.props.post &&*/}
                                    {/*  <Link to={`posts/${this.props.post.slug}`} className="viewall">{getLabel(207)}</Link>*/}
                                    {/*}*/}
                                </div>)
                            })}
                            {!this.props.showComments &&
                            this.props.comments &&
                            this.props.comments.reverse().slice(0, 2).map((Comment, index) => {
                                return (<div>
                                    <SmallComment
                                        {...Comment}
                                        mention={this.props.mentions}
                                        avatar={defaultAvatar}
                                        post={this.props.post}
                                        posts={this.props.posts}
                                        showComments={this.props.showComments}
                                        isAvailableForReply={this.props.isAvailableForReply}
                                    />
                                    {/*{this.props.comments.length > 1 && this.props.post &&*/}
                                    {/*  <Link to={`posts/${this.props.post.slug}`} className="viewall">{getLabel(207)}</Link>*/}
                                    {/*}*/}
                                </div>)
                            })}
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, null)(SmallCommentContainer);
